import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import * as moment from 'moment'
import { FilterUtils } from 'primeng/utils'
import { Table } from 'primeng/table'
import { RequestsService } from 'src/app/_shared/services/requests.service'
import { ReferralService } from '../referral.service'

@Component({
  selector: 'app-referral-details',
  templateUrl: './referral-details.component.html',
  styleUrls: ['../referrals.component.scss'],
})
export class ReferralDetailsComponent implements OnInit {
  isLoading: boolean = false
  activePage: number = 1
  limit: number = 20
  data: any[] = []
  search: any
  total: number = 0
  rangeDates: Date[]
  selectedItems = []
  commissionRate$ = this.referralService.referralsCommissionRate$
  cols = [
    { field: 'name', header: 'Name' },
    { field: 'amount_paid', header: 'Amount Paid' },
    { field: 'user_contact', header: 'Contact' },
    { field: 'district', header: 'District' },
  ]

  @ViewChild('dt') private _table: Table

  referralsData$ = this.referralService.referrals$
  constructor(
    private requestService: RequestsService,
    private referralService: ReferralService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.params.id
    this.getData(id)

    FilterUtils['dateRangeFilter'] = (value, filter): boolean => {
      if (
        filter === undefined ||
        filter === null ||
        filter[0] === undefined ||
        filter[0] === null
      ) {
        return true
      }

      if (value === undefined || value === null) {
        return false
      }

      if (filter[1] === undefined || filter[1] === null) {
        return moment(value) >= moment(filter[0])
      }
      return (
        moment(value) >= moment(filter[0]) &&
        moment(value) <= moment(filter[1]).add(23.9999, 'hours')
      )
    }
  }

  getData(id: string) {
    this.referralService.loadRefferred(id)
    this.referralService.loadSummary(id)
  }

  displayActivePage(activePageNumber: number) {
    this.activePage = activePageNumber
  }

  filterByDate(event) {
    this._table.filter(this.rangeDates, 'referred_at', 'dateRangeFilter')
  }
}
